import { IDomEditor } from "@wangeditor/editor";
import { Editor } from "@wangeditor/editor-for-react";
import "@wangeditor/editor/dist/css/style.css";
import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";

const DocumentPage: React.FC = () => {
  const [editor, setEditor] = useState<IDomEditor | null>(null);
  const [content, setContent] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { app, agreement } = useParams<{ app: string; agreement: string }>();

  const getPreviewData = useCallback(async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const url = `${process.env.REACT_APP_ASSETS_BASE_URL}/agreement/${app}/${agreement}.json`;
      const response = await fetch(url);
      const { title, content } = await response.json();
      document.title = title || "Mystimeow";
      setContent(content);
    } catch (error) {
      console.error("获取数据失败:", error);
    } finally {
      setIsLoading(false);
    }
  }, [app, agreement, isLoading]);

  useEffect(() => {
    getPreviewData();
  }, []);

  useEffect(() => {
    if (editor && content) {
      editor.setHtml(content);
    }
  }, [editor, content]);

  const editorConfig = {
    readOnly: true,
    autoFocus: false,
  };

  return (
    <Editor
      defaultConfig={editorConfig}
      onCreated={setEditor}
      mode="default"
      style={{ height: "auto", border: "none" }}
    />
  );
};

export default DocumentPage;
